import styled from "styled-components"

export const BackProfileButton = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  button {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    border-radius: 10px;
    color: #000;
    font-size: 20px;
  }
  span {
    text-transform: capitalize;
    color: black;
  }
`;